import uuid from 'src/nativeModules/UUID';
import {HistoryComponentProps} from '../HistoryComponent';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import AccountStore from 'src/stores/AccountStore';
import AccountConstants from 'src/constants/AccountConstants';
import ActionsFactory from 'src/actions/ActionsFactory';
import Events from 'src/logging/Events';
import CrashlyticsEvents from 'src/logging/Crashlytics';
import {generateErrorMessage} from 'src/logging/generateErrorMessage';

export const useRefreshHistory = async (
  props: HistoryComponentProps,
  pageNo: number,
  accountId: string,
  setFundingPageNumber: React.Dispatch<React.SetStateAction<number>>,
  setPageNumber: React.Dispatch<React.SetStateAction<number>>,
  setIsRefreshing: React.Dispatch<React.SetStateAction<boolean>>,
) => {

  FirebaseAnalytic.trackEvent('onRefresh', 'HistoryComponent', {
    ...props,
  });
  try {
    if (props.historyfilter === AccountConstants.FUNDING_TYPE) {
      await ActionsFactory.getAccountActions().loadPurchaseHistory(
        accountId,
        pageNo,
        AccountConstants.FUNDING_TYPE,
      );

      setFundingPageNumber(pageNo);
    } else if (props.historyfilter === AccountConstants.REDEMPTION_TYPE) {
      await ActionsFactory.getAccountActions().loadPurchaseHistory(
        accountId,
        pageNo,
        AccountConstants.REDEMPTION_TYPE,
      );
      setFundingPageNumber(pageNo);
    } else if (props.historyfilter === AccountConstants.SEND_SNACK) {
      const accountId = AccountStore.getAccountId();
      const _pageNo = pageNo;

      const promises = [
        ActionsFactory.getAccountActions().loadPurchaseHistory(
          accountId,
          _pageNo,
          AccountConstants.SEND_SNACK,
        ),
        ActionsFactory.getAccountActions().loadPurchaseHistory(
          accountId,
          _pageNo,
          AccountConstants.SEND_SNACK_CANCEL,
        ),
        ActionsFactory.getAccountActions().loadPurchaseHistory(
          accountId,
          _pageNo,
          AccountConstants.SEND_SNACK_REVERSE,
        ),
        ActionsFactory.getAccountActions().loadPurchaseHistory(
          accountId,
          _pageNo,
          AccountConstants.SEND_SNACK_ACCEPT,
        ),
        ActionsFactory.getAccountActions().loadPurchaseHistory(
          accountId,
          _pageNo,
          AccountConstants.SEND_SNACK_EXPIRE,
        ),
      ];

      // Run all promises in parallel
      await Promise.all(promises);

      setFundingPageNumber(pageNo);
    } else if (props.historyfilter === AccountConstants.SALE_TYPE) {
      await ActionsFactory.getAccountActions().loadPurchaseHistory(
        accountId,
        pageNo,
        AccountConstants.SALE_TYPE,
      );
      setFundingPageNumber(pageNo);
    } else if (props.historyfilter === AccountConstants.MARKET_PURCHASES) {
      await ActionsFactory.getAccountActions().loadPurchaseHistory(
        accountId,
        pageNo,
        AccountConstants.SALE_TYPE,
        AccountConstants.MARKET_PURCHASES,
      );
      setFundingPageNumber(pageNo);
    } else if (props.historyfilter === AccountConstants.MOBILE_PURCHASES) {
      await ActionsFactory.getAccountActions().loadPurchaseHistory(
        accountId,
        pageNo,
        AccountConstants.SALE_TYPE,
        AccountConstants.MOBILE_PURCHASES,
      );
      setFundingPageNumber(pageNo);
    } else if (props.historyfilter === AccountConstants.REFERRAL_TYPE) {
      await ActionsFactory.getAccountActions().loadPurchaseHistory(
        accountId,
        pageNo,
        AccountConstants.REFERRAL_TYPE,
      );
      setFundingPageNumber(pageNo);
    } else if (
      props.historyfilter === AccountConstants.SIGN_UP_REWARDS ||
      props.historyfilter === AccountConstants.REFERRAL_SIGNUP_TYPE
    ) {
      await ActionsFactory.getAccountActions().loadPurchaseHistory(
        accountId,
        pageNo,
        AccountConstants.REFERRAL_SIGNUP_TYPE,
      );
      setFundingPageNumber(pageNo);
    } else if (props.historyfilter === AccountConstants.ADJUSTMENT_TYPE) {
      await ActionsFactory.getAccountActions().loadPurchaseHistory(
        accountId,
        pageNo,
        AccountConstants.ADJUSTMENT_TYPE,
      );
      setFundingPageNumber(pageNo);
    } else {
      await ActionsFactory.getAccountActions().loadPurchaseHistory(
        accountId,
        pageNo,
      );
      setPageNumber(pageNo);
    }
  } catch (error) {
    const guid = await uuid.getRandomUUID();
    CrashlyticsEvents.log(
      'Exception',
      'HistoryComponent:onRefresh',
      generateErrorMessage(error),
      guid,
    );
    Events.Error.trackEvent(
      'Exception',
      'HistoryComponent:onRefresh',
      generateErrorMessage(error),
      guid,
    );
  } finally {
    setIsRefreshing(false);
  }
};
